// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__ppo3p","cart":"styles_cart__z7XbW"};